import React from 'react';
import PropTypes from 'prop-types';
import RequiredAsterisk from '../RequiredAsterisk';

const ReportRequiredLabel = ({ children }) => (
  <span>
    {children}
    <RequiredAsterisk />
  </span>
);

ReportRequiredLabel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default ReportRequiredLabel;



// WEBPACK FOOTER //
// src/components/shared/ReportRequiredLabel/index.jsx